import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {NavService} from '../../services/nav.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { Subscription } from 'rxjs';
import { NavItem } from 'src/app/interfaces/nav-item';
import { TabService } from 'src/app/services/tab.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { HTTPService } from 'src/app/services/http.service';

@Component({
    selector: 'app-menu-list-item',
    templateUrl: './menu-list-item.component.html',
    styleUrls: ['./menu-list-item.component.scss'],
    animations: [
        trigger('indicatorRotate', [
            state('collapsed', style({ transform: 'rotate(0deg)' })),
            state('expanded', style({ transform: 'rotate(180deg)' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
        ])
    ],
    standalone: false
})
export class MenuListItemComponent implements OnInit {
  //@Input() expanded: boolean  = false;
  @Input() item: NavItem;
  @HostBinding('attr.aria-expanded') ariaExpanded;
  
  @Input() depth: number;
  @Input() routeName: string;
  useTab:boolean = false;
  sub:Subscription;
  

  constructor(public navService: NavService,
              public router: Router,
              public tabService:TabService,
              private UserAuthenticationServices:UserAuthenticationServices,
              private http:HTTPService) {

    
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    
    this.useTab = this.UserAuthenticationServices.user.usetab == null ? false :
                    this.UserAuthenticationServices.user.usetab == 'S' ? true:false;

    this.ariaExpanded  = this.item.expanded;
    this.sub = this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {

        this.item.expanded = url.indexOf(`/${this.item.route}`) === 0;
        this.ariaExpanded = this.item.expanded;

      }
    });
  }

  ngOnDestroy(){
    if (this.sub!= null ) {this.sub.unsubscribe();}
  }

  onItemSelected(item: NavItem) {
    this.navService.selectItem(item, this.useTab, this.router, this.tabService, this.routeName, this.UserAuthenticationServices.user.iduser);    
    if (item.children && item.children.length) {
      this.item.expanded = !this.item.expanded;
    }
  }

}
